require('./bugsnag.ts')
require('./element.ts')
require('./vuex.ts')
require('./permissions.ts')
require('./dd-error-handler.ts')
require('./vue-meta.ts')
require('./dd-notification.ts')
require('./body-scroll.ts')
require('./device-info.ts')
require('./vcalendar.ts')
require('./vue-content-placeholders.ts')
require('./vue-mq.ts')
require('./dd-strings.ts')
/* Require any /dd-extensions at the end since they depend on prior plugins */
require('./element-dd-extension.ts')
require('./vue-mq-dd-extension.ts')
require('./vue-pusher.ts')
